import {
  SET_PROMO_CODES_LOADING,
  SET_PROMO_CODES,
  SET_PROMO_CODE_LOADING,
  SET_PROMO_CODE,
  SET_CREATE_PROMO_CODE_LOADING,
  SET_UPDATE_PROMO_CODE_LOADING,
} from './promo_codes_actions';

const EMPTY_ENTITIES = {
  data: null,
  isLoading: false,
};

export const INITIAL_STATE = {
  promoCodes: EMPTY_ENTITIES,
  promoCode: EMPTY_ENTITIES,
  isCreatingPromoCode: false,
  isUpdatingPromoCode: false,
};

const actionHandlers = {
  [SET_PROMO_CODES_LOADING]: state => {
    const promoCodes = { ...state.promoCodes, isLoading: true };
    return { ...state, promoCodes };
  },
  [SET_PROMO_CODES]: (state, action) => {
    const { data } = action.payload;
    const promoCodes = { data, isLoading: false };
    return { ...state, promoCodes };
  },
  [SET_PROMO_CODE_LOADING]: state => {
    const promoCode = { ...state.promoCode, isLoading: true };
    return { ...state, promoCode };
  },
  [SET_PROMO_CODE]: (state, action) => {
    const { data } = action.payload;
    const promoCode = { data, isLoading: false };
    return { ...state, promoCode };
  },
  [SET_CREATE_PROMO_CODE_LOADING]: (state, { params }) => {
    return { ...state, isCreatingPromoCode: params };
  },
  [SET_UPDATE_PROMO_CODE_LOADING]: (state, { params }) => {
    return { ...state, isUpdatingPromoCode: params };
  },
};

export const reducer = (state, action) => {
  const handler = actionHandlers[action.type];

  return handler ? handler(state, action) : state;
};
